import React, {useCallback, useState} from 'react'
import app from './App.module.scss'
import Main from '../../pages/Main/Main'
import Header  from '../Header/Header'
import Footer  from '../Footer/Footer'
import UpButton from '../UpButton/UpButton'
import Modal from '../../components/Modal/Modal'
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy'
import ModalImage from '../ModalImage/ModalImage'

function App() {

  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isPopupPrivacyPolicyOpen, setIsPopupPrivacyPolicyOpen] = useState(false)
  const [isPopupImageOpen, setIsPopupImageOpen] = useState(false)

  const vh = window.innerHeight / 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const handleOpen = useCallback(() => {
    setIsPopupOpen(true)
  }, []);

  const handleClose = useCallback(() => {
    setIsPopupOpen(false)
  }, []);

  const handlePrivacyPolicyClose = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(false)
  }, []);

  const handlePrivacyPolicyOpen = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(true)
  }, [])

  const handleImageClose = useCallback(() => {
    setIsPopupImageOpen(false)
  }, []);

  const handleImageOpen = useCallback(() => {
      setIsPopupImageOpen(true)
  }, [])


  return (
    <div className={app.page}>
      <Header
      />
      <Main
        popupOpen={handleOpen}
        isImageOpen={handleImageOpen}
      />
      {isPopupOpen && 
      <Modal
        onClose={handleClose}
      />}
      {isPopupPrivacyPolicyOpen && 
      <PrivacyPolicy
        onClose={handlePrivacyPolicyClose}
      />}
      <Footer
        isOpen={handlePrivacyPolicyOpen}
      />
      <UpButton/>
      {isPopupImageOpen && 
      <ModalImage
        onClose={handleImageClose}
      />}
    </div>
  );
}

export default App;
